module.exports = __webpack_public_path__ + "static/img/1.8048b68.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/1.png
// module id = lJXw
// module chunks = 0